export default {
    DEFAULT_ACTION: 'member/default',
    SET_IS_FETCHING_GEOLOCATION: 'MEMBER/SET_IS_FETCHING_GEOLOCATION',
    SET_GEOLOCATION: 'MEMBER/SET_GEOLOCATION',
    FAILED_LOADING_GEOLOCATION: 'MEMBER/FAILED_LOADING_GEOLOCATION',
    SET_MEMBER_HERO_IMAGE: 'MEMBER/SET_MEMBER_HERO_IMAGE'
};
